export default __webpack_public_path__ + "static/media/instant-screen-name.1fde18ce.svg";